export const START = 'START' as const;
export const END = 'END' as const;
